import { Action } from 'redux';
import { AuthState, UserInfo } from 'src/store';

export const actionTypes = {
  LOGGING_IN: 'auth/LOGGING_IN',
  LOGOUT_REQUEST: 'auth/LOGOUT_REQUEST',
  LOGGED_OUT: 'auth/LOGGED_OUT',
  LOGGED_IN: 'auth/LOGGED_IN',
};

const {
  LOGGED_IN,
  LOGOUT_REQUEST,
  LOGGED_OUT,
} = actionTypes;

export namespace actions {
  export function loggingIn() {
    return {
      type: actionTypes.LOGGING_IN,
      payload: {}
    };
  }
  export function loggedIn(userInfo: UserInfo) {
    return {
      type: LOGGED_IN,
      payload: { userInfo },
    };
  }

  export function logOutRequest() {
    return {
      type: LOGOUT_REQUEST,
      payload: {},
    };
  }

  export function loggedOut() {
    return {
      type: LOGGED_OUT,
      payload: {},
    };
  }
}

export namespace reducers {
  type LoggedAction = Action & { payload: { userInfo: UserInfo } | { error: string } };
  export const authReducer = (state: AuthState = { status: 'none' }, action: LoggedAction) => {
    switch (action.type) {
      case actionTypes.LOGGING_IN: {
        return {
          status: 'loading',
        };
      }
      case LOGGED_IN: {
        const { userInfo } = action.payload as { userInfo: UserInfo };
        return {
          status: 'loggedIn',
          userInfo,
        };
      }
      case LOGGED_OUT:
        return { status: 'none' };
      default:
        break;
    }

    return state;
  };
}



// WEBPACK FOOTER //
// ./src/auth/redux.ts